export default {"src":"/_next/static/media/tick.b92de060.svg","height":8,"width":9,"blurWidth":0,"blurHeight":0};